//Orderbook
export const SET_HIDDEN = 'set_hidden';
export const FETCHED_ORDERS = 'fetched_orders';
export const FETCHED_PAIRS = 'fetched_pairs';
export const FETCHED_SUB_DEMAND_OFFERS = 'fetched_sub_demand_offers';
export const FETCHED_MY_ORDERS = 'fetched_my_orders';
export const FETCHED_MATCHED_ORDERS = 'fetched_matched_orders';
export const FETCHED_MY_MATCHED_ORDERS = 'fetched_my_matched_orders';
export const FETCHED_PAST_ORDERS = 'fetched_past_orders';
export const FETCHED_MY_PAST_ORDERS = 'fetched_my_past_orders';
export const FETCHED_MATCHED_PAIRS = 'fetched_matched_pairs';
export const FETCHED_STATS = 'fetched_stats';
export const FETCHED_MY_UNMATCHED_ORDERS = 'fetched_my_unmatched_orders';
export const FETCHED_MAKER_MAP = 'fetched_maker_map';
export const FETCHED_MY_MAKER_MAP = 'fetched_my_maker_map';
export const ADD_TO_MAKER_MAP = 'add_to_maker_map';

//Passport
export const FETCHED_NRG = "fetched_nrg";
export const FETCHED_BALANCE = 'fetched_balance';
export const FETCHED_SPENDABLE_OUTPOINTS = 'fetched_spendable_outpoints';
export const TRADE_ADDRESS_SET = 'trade_address_set';
export const FETCHED_FEE = 'fetched_fee';

export const WALLET_SET = "wallet_set";
export const REMOVE_WALLET = 'remove_wallet';
export const REMOVE_ASSET = 'remove_asset';


//Pending
export const SET_PENDING_TRANSACTIONS = "pending_transactions";
export const OVERRIDE_PENDING_TRANSACTIONS = "override_transactions";
export const SET_MULTIPLE_PENDING_TRANSACTIONS = 'SET_MULTIPLE_PENDING_TRANSACTIONS';

//Settings
export const SET_SETTINGS = 'set_settings';

//Socket
export const SOCKET_CONNECTED = 'SOCKET_CONNECTED';
export const SOCKET_DISCONNECTED = 'SOCKET_DISCONNECTED';
export const BLOCKS_MINED_ADD = "BLOCKS_MINED_ADD";
export const RETRIEVING_DATA = 'retreiving_data';
export const CHANGE_SOCKET = 'change_socket';
export const SOCKET_CREATED = 'socket_created';
export const NO_RPC = 'no_rpc';

//Transfer History
export const FETCHED_HISTORY = "fetched_history";
export const LAST_NRG_TX = 'last_nrg_tx';

//Marketplace UI
export const SET_PRICE = "set_price";
export const SET_AMOUNT = "set_amount";
export const SET_COLLATERAL = "set_collateral";
export const SET_ORDER_TYPE = "set_order_type";
export const SET_HELP = "set_help";
export const SET_MARKET = "set_market";
export const SET_FINAL_ORDER = 'set_final_order';
export const SET_MAKER_COLLATERAL = 'set_maker_collateral'
export const SET_MATCHING = 'set_matching';

//Passport UI
export const SET_LOADING_TXS='set_loading_txs';
export const SET_LOADING='set_loading';
export const SET_PASSPORT_FEE = "set_passport_fee";
export const SET_PASSPORT_AMOUNT = "set_passport_amount";
export const SET_PASSPORT_ASSET_VIEW = "set_passport_asset_view";

//SCHEDULED Events
export const NEW_EVENT = 'new_event';
export const REMOVE_EVENT = 'remove_event';

//PRICE
export const FETCHED_PRICE = 'fetched_price';


//mempool
export const MEM_MAKERS = 'MEM_MAKERS';
export const MEM_TAKERS = 'MEM_TAKERS';
export const MEM_TRANSFERS = 'MEM_TRANSFERS';
